import { Flex, Text } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';
import { OptionEntity } from '@/types/OptionEntity';

import s from './MobileTabs.module.scss';

export type NoteTabData = OptionEntity & {
  disabled?: boolean;
};

export type Props = {
  items: NoteTabData[];
  activeKey: string | null;
  onChange: (key: string) => void;
};

const MobileTabs: React.FC<Props> = ({ items, activeKey, onChange }) => {
  return (
    <Flex className={s.root} align="center">
      {items.map((item) => {
        const isActive = activeKey === item.key;

        return (
          <BaseClickable
            withHover
            disabled={item.disabled}
            className={cn(s.root__tab, isActive && s.root__tab_active, item.disabled && s.root__tab_disabled)}
            key={item.key}
            onClickWithValue={onChange}
            value={item.key}
          >
            <Text size="xs">{item.value}</Text>
          </BaseClickable>
        );
      })}
    </Flex>
  );
};

export default React.memo(MobileTabs);
